import { render, staticRenderFns } from "./JobMatching.vue?vue&type=template&id=513978d8"
import script from "./JobMatching.vue?vue&type=script&lang=js"
export * from "./JobMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports